import type { CSSProperties, ReactNode } from 'react'

export interface BottomSheetProps {
  open: boolean
  onClose: () => void
  title?: string
  children: ReactNode
}

export function BottomSheet({ open, onClose, title, children }: BottomSheetProps) {
  if (!open) return null
  const backdropStyle: CSSProperties = {
    position: 'fixed', inset: 0,
    background: 'rgba(0,0,0,0.5)',
    zIndex: 100,
  }
  const sheetStyle: CSSProperties = {
    position: 'fixed', left: 0, right: 0, bottom: 0,
    background: 'var(--color-surface)',
    borderRadius: 'var(--radius-xl) var(--radius-xl) 0 0',
    borderTop: '1px solid var(--color-border)',
    padding: 'var(--space-4)',
    paddingBottom: 'calc(var(--space-4) + env(safe-area-inset-bottom, 0))',
    maxHeight: '85vh',
    overflowY: 'auto',
    zIndex: 101,
    boxShadow: 'var(--shadow-lg)',
  }
  const handleStyle: CSSProperties = {
    width: 36, height: 4, background: 'var(--color-border-strong)',
    borderRadius: 'var(--radius-pill)',
    margin: '0 auto var(--space-3)',
  }
  const titleStyle: CSSProperties = {
    fontSize: 'var(--font-size-lg)',
    fontWeight: 700,
    color: 'var(--color-text)',
    marginBottom: 'var(--space-3)',
  }
  return (
    <>
      <div
        data-testid="bottom-sheet-backdrop"
        style={backdropStyle}
        onClick={onClose}
      />
      <div style={sheetStyle} role="dialog" aria-modal="true">
        <div style={handleStyle} />
        {title && <div style={titleStyle}>{title}</div>}
        {children}
      </div>
    </>
  )
}
